var render, staticRenderFns
import script from "./select_template.vue?vue&type=script&lang=js&"
export * from "./select_template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0285cdba')) {
      api.createRecord('0285cdba', component.options)
    } else {
      api.reload('0285cdba', component.options)
    }
    
  }
}
component.options.__file = "found/views/dms/views/contract/contract_manage/form/select_template.vue"
export default component.exports